import { render } from "./UnlockedUserPosts.vue?vue&type=template&id=1722a67e"
import script from "./UnlockedUserPosts.vue?vue&type=script&lang=js"
export * from "./UnlockedUserPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__